import type { AddressKind, TechnicianAddress } from 'api/techniciansApi';

const hasText = ({ line1, postalCode, city }: TechnicianAddress): boolean =>
  [line1, postalCode, city].some((part) => part?.trim());

/** A saved address with text and no position (pending or not found); `null` when located or never saved. */
export const unplacedAddress = (stored: TechnicianAddress[], kind: AddressKind): TechnicianAddress | null => {
  const saved = stored.find((address) => address.kind === kind);
  return saved && saved.geocodeState !== 'located' && hasText(saved) ? saved : null;
};

/** Same rule as the directory's `unlocated`: any address the geocoder could not place. */
export const hasUnlocatedAddress = (stored: TechnicianAddress[]): boolean =>
  stored.some((address) => address.geocodeState === 'not_found' && hasText(address));

export const hasPendingAddress = (stored: TechnicianAddress[]): boolean =>
  stored.some((address) => address.geocodeState === 'pending');
